import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { ExternalLink } from 'lucide-react';
import { readResponse } from '../utils/fetchSafe';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const FranchiseLocations = () => {
  const navigate = useNavigate();
  const [franchises, setFranchises] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchFranchises(); }, []);

  const fetchFranchises = async () => {
    try {
      const res = await fetch(`${API_URL}/api/franchise-locations`);
      const { data } = await readResponse(res);
      setFranchises(data.franchises || []);
    } catch { toast.error('Failed to load franchises'); }
    finally { setLoading(false); }
  };

  return (
    <Layout>
      <div className="p-4 lg:p-8">
        <div className="mb-6">
          <h2 className="text-lg text-[#5B8DB8] font-light">Setup</h2>
          <h1 className="text-3xl text-gray-700 font-light italic">Franchises</h1>
        </div>

        <div className="mb-6">
          <button
            onClick={() => navigate('/setup')}
            className="bg-gray-500 hover:bg-gray-600 text-white px-6 py-2 rounded transition-colors"
            data-testid="back-btn"
          >
            Back
          </button>
        </div>

        <div className="bg-white rounded shadow p-6 lg:p-8">
          <div className="mb-8">
            <div className="flex items-start gap-2">
              <span className="bg-[#FFA94D] text-white text-xs font-bold px-2 py-1 rounded flex-shrink-0">Hint</span>
              <p className="text-gray-600 text-sm">Enter Franchise information, multiple franchises may be added if applicable. When entering multiple franchises select a unique color for each location for visual identification.</p>
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid="franchise-table">
              <thead>
                <tr className="border-b-2">
                  <th className="text-left p-3 text-gray-600 font-normal italic">Franchise Name</th>
                  <th className="text-left p-3 text-gray-600 font-normal italic">Color</th>
                  <th className="text-left p-3 text-gray-600 font-normal italic">Number</th>
                  <th className="text-left p-3 text-gray-600 font-normal italic">General Inbox</th>
                  <th className="text-left p-3 text-gray-600 font-normal italic">Street Address</th>
                  <th className="text-left p-3 text-gray-600 font-normal italic">City</th>
                  <th className="text-left p-3 text-gray-600 font-normal italic">State</th>
                  <th className="text-left p-3 text-gray-600 font-normal italic">Zip</th>
                  <th className="text-left p-3 text-gray-600 font-normal italic">Vehicle Daily Rate</th>
                  <th className="text-left p-3 text-gray-600 font-normal italic">Primary</th>
                  <th className="p-3"></th>
                  <th className="p-3"></th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan="12" className="p-4 text-center text-gray-500">Loading...</td></tr>
                ) : franchises.length === 0 ? (
                  <tr><td colSpan="12" className="p-4 text-center text-gray-500 italic">No franchises found</td></tr>
                ) : (
                  franchises.map((f, idx) => (
                    <tr key={idx} className={`border-b ${idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`} data-testid={`franchise-row-${idx}`}>
                      <td className="p-3 text-gray-700">{f.name}</td>
                      <td className="p-3">
                        <div
                          className="w-8 h-8 rounded"
                          style={{ backgroundColor: f.color || '#ccc' }}
                        />
                      </td>
                      <td className="p-3 text-gray-700">{f.number}</td>
                      <td className="p-3 text-gray-700">{f.general_inbox || ''}</td>
                      <td className="p-3 text-gray-700">{f.street_address}</td>
                      <td className="p-3 text-gray-700">{f.city}</td>
                      <td className="p-3 text-gray-700">{f.state}</td>
                      <td className="p-3 text-gray-700">{f.zip}</td>
                      <td className="p-3 text-gray-700">{f.vehicle_daily_rate}</td>
                      <td className="p-3 text-gray-700">{f.primary ? 'Yes' : 'No'}</td>
                      <td className="p-3 text-gray-400">--</td>
                      <td className="p-3">
                        <button onClick={() => navigate(`/setup/franchise-locations/${f.number}`)} className="border border-gray-300 rounded p-1 hover:bg-gray-100" data-testid={`edit-franchise-${idx}`}>
                          <ExternalLink className="w-4 h-4 text-gray-500" />
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default FranchiseLocations;
